// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const RadiusIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="RadiusIcon" ref={forwardedRef} {...props}>
      <path d="M18 4.75a2.74 2.74 0 0 1-.742 1.88 8 8 0 1 1-3.887-3.887A2.75 2.75 0 0 1 18 4.75M10 16.5a6.5 6.5 0 0 0 5.962-9.093 2.76 2.76 0 0 1-2.053-.255l-2.46 2.46a1.5 1.5 0 1 1-1.06-1.06l2.46-2.461a2.74 2.74 0 0 1-.256-2.053A6.5 6.5 0 1 0 10 16.5m6.411-11.286a1.25 1.25 0 1 0-2.322-.928 1.25 1.25 0 0 0 2.322.928" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const RadiusIcon = /* @__PURE__ */ Object.assign(RadiusIconComponent, {
  displayName: 'RadiusIcon',
});
